import { Controller } from '@hotwired/stimulus';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { parseOptionQueryParam } from 'utils/option_util';

import app from 'domains/application';
import ui from 'domains/ui';
import canvases from 'domains/canvases';
import navigation from 'domains/navigation';

import { paramOptions, paramHeight, paramWidth, paramFilterDetail } from 'utils/globals';

import Wos from 'components/apps/Wos';
import store from 'store/wos_store';

// Connects to data-controller="wos-renderer"
export default class extends Controller {
  static values = {
    catalog: String,
    subcatalog: String,
    product: String,
  };

  declare catalogValue: string;
  declare subcatalogValue: string;
  declare productValue: string;

  connect() {
    this.render(this.catalogValue, this.subcatalogValue, this.productValue);
  }

  render = (c: string, s: string, p: string) => {
    const config = {
      catalog: (c && parseInt(c)) || undefined,
      subcatalog: (s && parseInt(s)) || undefined,
      product: (p && parseInt(p)) || undefined,
      options: parseOptionQueryParam(paramOptions),
      height: (paramHeight && paramHeight.length && parseFloat(paramHeight)) || undefined,
      width: (paramWidth && paramWidth.length && parseFloat(paramWidth)) || undefined,
    };

    store.dispatch(app.actions.initApp());
    store.dispatch(canvases.actions.createCanvas({ config }));
    store.dispatch(navigation.actions.initializeNavigation({ catalogSelector: !c && !s && !p }));
    store.dispatch(ui.actions.setShowAdvancedFilters(paramFilterDetail || !p));

    return render(
      <Provider store={store}>
        <Wos />
      </Provider>,
      this.element
    );
  };
}
